"use strict";

exports.__esModule = true;
exports.omit = omit;
exports.keys = keys;
exports.forEach = forEach;
exports.map = map;
exports.reduce = reduce;
//  weak
function omit(obj, testFn) {
  var target = {};
  var i = void 0;
  for (i in obj) {
    if (!testFn(i, obj)) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

function keys(obj) {
  var k = void 0;
  var out = [];
  for (k in obj) {
    out.push(k);
  }
  return out;
}

function forEach(arr, fn) {
  var i = 0;
  var len = arr.length;

  for (; i < len; i++) {
    fn(arr[i], i, arr);
  }
}

function map(arr, fn) {
  if (arr == null) {
    return [];
  }

  var i = 0;
  var len = arr.length;
  var out = new Array(len);

  for (; i < len; i++) {
    out[i] = fn(arr[i], i, arr);
  }

  return out;
}

function reduce(arr, fn, val) {
  if (arr == null) {
    return [];
  }

  var i = 0;
  var len = arr.length;
  var out = val;

  if (out === void 0) {
    out = arr[0];
    i = 1;
  }

  for (; i < len; i++) {
    out = fn(out, arr[i], i, arr);
  }

  return out;
}

var assign = exports.assign = Object.assign || function (target) {
  var i = 1;
  var length = arguments.length;
  for (; i < length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};


//////////////////
// WEBPACK FOOTER
// ./~/emotion/lib/utils.js
// module id = 2
// module chunks = 0